export type TemplateType = 'checklist' | 'incident';
export enum TemplateTypes {
    CHECKLIST = 'checklist',
    INCIDENT = 'incident'
}

export interface TemplateConfig {
    submitEndpoint: string;
    getEndpoint: string;
    routePrefix: string;
}

export interface TemplateBuilderProps {
    templateType?: TemplateType;
}

export type TemplateConfigs = {
    [key in TemplateTypes]: TemplateConfig;
}
